<template>
  <div class="overflow-auto bg-n-background w-full px-6">
    <div class="w-full pb-12">
      <router-view />
    </div>
  </div>
</template>
